import styled from 'styled-components';

import { breakpoints, fontFamily } from '../../ui/variables';

export const ExamReportListStyle = styled.div`
  padding: 0 20px;
  width: 100%;

  @media (min-width: ${breakpoints.hd.width}px) {
    padding: 0;
  }

  .exam-report-list-table-head {
    display: none;

    @media (min-width: ${breakpoints.hd.width}px) {
      display: flex;
      flex-wrap: nowrap;
      margin-bottom: 16px;
    }

    .table-head-list {
      &.result-item {
        @media (min-width: ${breakpoints.hd.width}px) {
          max-width: 88px;
          min-width: 88px;
          padding-left: 12px;
        }
      }

      &.information-list {
        @media (min-width: ${breakpoints.hd.width}px) {
          display: flex;
          max-width: calc(100% - 88px - 68px);
          min-width: calc(100% - 88px - 68px);
        }
      }

      &.action-list {
        @media (min-width: ${breakpoints.hd.width}px) {
          max-width: 68px;
          min-width: 68px;
        }
      }
    }

    .table-head-item {
      @media (min-width: ${breakpoints.hd.width}px) {
        ${fontFamily.sourceSansPro.regular};
        font-size: 12px;
        line-height: 15px;
      }

      &.exame-type-item {
        @media (min-width: ${breakpoints.hd.width}px) {
          max-width: 20%;
          min-width: 20%;
        }
      }

      &.medical-record-item {
        @media (min-width: ${breakpoints.hd.width}px) {
          max-width: 12%;
          min-width: 12%;
        }
      }

      &.patient-name-item {
        @media (min-width: ${breakpoints.hd.width}px) {
          max-width: 18%;
          min-width: 18%;
        }
      }

      &.registration-date-item {
        display: none;

        @media (min-width: ${breakpoints.hd.width}px) {
          display: block;
          max-width: 13%;
          min-width: 13%;
        }
      }
        
      &.exam-date-item {
        display: none;

        @media (min-width: ${breakpoints.hd.width}px) {
          display: block;
          max-width: 13%;
          min-width: 13%;
        }
      }

      &.medical-assistant-item {
        @media (min-width: ${breakpoints.hd.width}px) {
          max-width: 12%;
          min-width: 12%;
        }
      }

      &.status-item {
        @media (min-width: ${breakpoints.hd.width}px) {
          max-width: 16%;
          min-width: 16%;
        }
      }
    }
  }

  .exam-report-list-container {
    .exam-report-item-wrapper {
      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }
  }
`;
